module.exports = __webpack_public_path__ + "img/view-icon.16215d2e.svg";